const isChangeLang = false;
const headerTextFlag = false;

export const environment = {
	isChangeLang,
	production: true,
	project: "vesta-front",
	headerTextFlag
};
